/*
 * @Descripttion: 
 * @Author: dengyao
 * @Date: 2024-04-18 15:46:07
 * @LastEditors: hongye
 * @LastEditTime: 2026-03-20 09:16:49
 */
import { defineStore } from 'pinia'
import { commonService } from '@/service/api'
import { isSuccess } from '@/utils'

/** DictValueListVo */
interface DictValueListVo {
  dictCode?: string
  dictKey?: string
  dictValue?: string
  dictValueExtra1?: string
  dictValueExtra2?: string
  dictValueExtra3?: string
  dictValueExtra4?: string
  /** @format int64 */
  id?: number
  remark?: string
  dictValues: any
}
export const useDictStore = defineStore('dict', {
  state: () => ({
    /**数据字典 */
    dataDictList: [] as DictValueListVo[]
  }),
  actions: {
    getListDictDataList() {
      // 2024-12-23添加 FIRST_LEVEL_PROBLEM_TYPE：一级问题类型；SECONDARY_PROBLEM_TYPE：二级问题类型
      const dictCodeList = ['STATION_SYSTEM','FastParcelType','KindType','BagType','GoodsType', 'FIRST_LEVEL_PROBLEM_TYPE', 'SECONDARY_PROBLEM_TYPE']
       return new Promise((resolve, reject) => {
        commonService
          .getListDictDataList({ param:dictCodeList })
          .then((res) => {
            this.dataDictList = res.data
            if (!isSuccess(res)) return 
            resolve(res)
          })
          .catch((err) => reject(err))
      })
    }
  },
  persist: {
    storage: localStorage
  }
})
